/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BalanceEntryRequest
 */
export interface BalanceEntryRequest {
    /**
     * 
     * @type {string}
     * @memberof BalanceEntryRequest
     */
    id?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof BalanceEntryRequest
     */
    date: Date;
    /**
     * 
     * @type {number}
     * @memberof BalanceEntryRequest
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof BalanceEntryRequest
     */
    entryType?: string | null;
}

/**
 * Check if a given object implements the BalanceEntryRequest interface.
 */
export function instanceOfBalanceEntryRequest(value: object): value is BalanceEntryRequest {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function BalanceEntryRequestFromJSON(json: any): BalanceEntryRequest {
    return BalanceEntryRequestFromJSONTyped(json, false);
}

export function BalanceEntryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BalanceEntryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'date': (new Date(json['date'])),
        'amount': json['amount'],
        'entryType': json['entryType'] == null ? undefined : json['entryType'],
    };
}

export function BalanceEntryRequestToJSON(json: any): BalanceEntryRequest {
    return BalanceEntryRequestToJSONTyped(json, false);
}

export function BalanceEntryRequestToJSONTyped(value?: BalanceEntryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'date': `${value['date'].getFullYear()}-${String(value['date'].getMonth()+1).padStart(2,'0')}-${String(value['date'].getDate()).padStart(2,'0')}`,
        'amount': value['amount'],
        'entryType': value['entryType'],
    };
}

